import React, { useState } from 'react';
import { useTheme } from '../App';
import { useNavigate } from 'react-router-dom';

function Header({ username, onLogout }) {
  const { theme, currentTheme, setCurrentTheme, themes } = useTheme();
  const navigate = useNavigate();
  const [showThemeMenu, setShowThemeMenu] = useState(false);

  const titleBarStyle = {
    backgroundColor: theme.colors.background2,
    padding: '5px 15px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '-10px -20px 15px -20px',
    position: 'relative',
  };

  const titleStyle = {
    color: theme.colors.accentGreen,
    fontSize: '16px',
    fontWeight: 600,
  };

  const themeButtonStyle = {
    background: 'transparent',
    border: 'none',
    color: theme.colors.accentCyan,
    cursor: 'pointer',
    fontSize: '16px',
    padding: '0 12px',
    position: 'relative',
  };

  const themeMenuStyle = {
    position: 'absolute',
    top: '100%',
    right: '0',
    backgroundColor: theme.colors.background,
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px',
    marginTop: '5px',
    minWidth: '150px',
    zIndex: 1000,
    boxShadow: `0 2px 10px ${theme.colors.shadow}`,
  };

  const themeOptionStyle = {
    padding: '8px 15px',
    cursor: 'pointer',
    fontSize: '15px',
    transition: 'background-color 0.2s',
  };

  return (
    <div style={titleBarStyle}>
      <span style={titleStyle}>&#xf007; {username}@readdit-terminal</span>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <div style={{ position: 'relative' }}>
          <button 
            style={themeButtonStyle}
            onClick={() => setShowThemeMenu(!showThemeMenu)}
            onBlur={() => setTimeout(() => setShowThemeMenu(false), 200)}
          >
            🎨
          </button>
          
          {showThemeMenu && (
            <div style={themeMenuStyle}>
              {Object.entries(themes).map(([key, themeOption]) => (
                <div
                  key={key}
                  style={{
                    ...themeOptionStyle,
                    backgroundColor: key === currentTheme ? theme.colors.background2 : 'transparent',
                    color: key === currentTheme ? theme.colors.accentGreen : theme.colors.foreground,
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = theme.colors.background2}
                  onMouseLeave={(e) => e.target.style.backgroundColor = key === currentTheme ? theme.colors.background2 : 'transparent'}
                  onClick={() => {
                    setCurrentTheme(key);
                    setShowThemeMenu(false);
                  }}
                >
                  {themeOption.name}
                </div>
              ))}
            </div>
          )}
        </div>
        {/* Search page button */}
        <button
          style={themeButtonStyle}
          onClick={() => navigate('/search')}
        >
          🔍
        </button>
        
        <button onClick={onLogout}>Logout</button>
      </div>
    </div>
  );
}

export default Header;